import http from '@/utils/http'

/**
 *  版本列表
*/
export function getVersionList(params) {
    return http({
        method: 'get',
        url: '/system/sysVersion/paging',
        params
    })
}

/**
 *  版本添加
*/
export function versionAdd(data) {
    return http({
        method: 'post',
        url: '/system/sysVersion/add',
        data
    })
}

/**
 *  版本删除
*/
export function versionDel(data) {
    return http({
        method: 'post',
        url: '/system/sysVersion/delete',
        params: data
    })
}

/**
 *  检查版本更新
*/
export function versionCheck(params) {
    return http({
        method: 'get',
        url: '/system/sysVersion/checkVersion',
        params
    })
}